// TextBot Sync-Bots API client (PR-S3).
// Server-side base path: /api/textbot-sync. Same-tenant copy-request flow.

import { apiGet, apiPost } from '../lib/api.js';

const BASE = '/textbot-sync';

export const createSyncRequest = ({ targetEmail, botIds = [] }) =>
  apiPost(`${BASE}/requests`, { targetEmail, botIds });

export const listSyncRequests = (box = 'incoming', status) => {
  const q = new URLSearchParams();
  if (box) q.set('box', box);
  if (status) q.set('status', status);
  const qs = q.toString();
  return apiGet(`${BASE}/requests${qs ? `?${qs}` : ''}`);
};

export const getPendingCount = () => apiGet(`${BASE}/requests/pending-count`);

export const acceptSyncRequest = (id, botIds = []) =>
  apiPost(`${BASE}/requests/${id}/accept`, { botIds });

export const declineSyncRequest = (id) => apiPost(`${BASE}/requests/${id}/decline`, {});

export const cancelSyncRequest = (id) => apiPost(`${BASE}/requests/${id}/cancel`, {});
